import React from 'react';
import Select, { GroupBase, Props } from 'react-select';
import overriddenSelectComponents from './override';
import { getSelectStyles } from './styles';
import { SelectOption } from './types';

export type UDSelectProps<isMulti extends boolean = boolean, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>> = Omit<
  Props<SelectOption, isMulti, Group>,
  'hideSelectedOptions' | 'isSearchable' | 'styles'
> & {
  divProps?: React.HTMLAttributes<HTMLDivElement>;
  hasError?: boolean;
};

export const UDSelect = <isMulti extends boolean = false, Group extends GroupBase<SelectOption> = GroupBase<SelectOption>>(
  props: UDSelectProps<isMulti, Group>,
) => {
  const { components, divProps, isDisabled, ...restProps } = props;

  const styles = getSelectStyles<isMulti, Group>();
  const selectComponents = components || overriddenSelectComponents;

  return (
    <div {...divProps} onClick={(e) => e.stopPropagation()} style={{ cursor: isDisabled ? 'not-allowed' : undefined }}>
      <Select
        {...restProps}
        isDisabled={isDisabled}
        data-error={restProps.hasError}
        hideSelectedOptions={false}
        placeholder={restProps.placeholder || ''}
        closeMenuOnSelect={!restProps.isMulti}
        isSearchable={false}
        styles={styles}
        components={selectComponents}
      />
    </div>
  );
};
